import { defineAsyncComponent } from 'vue';

export * from './useQuote';

export { default as QuoteAutoSuggest } from './components/QuoteAutoSuggest';

export const quoteMicroFrontends = {
	QuoteRevenueModal: defineAsyncComponent(
		() => import('./components/QuoteRevenueModal/QuoteRevenueModal.vue')
	),
	QuoteMatrix: defineAsyncComponent(
		() => import('./components/QuoteMatrix/QuoteMatrix.vue')
	),
	QuoteMatrixModal: defineAsyncComponent(
		() => import('./components/QuoteMatrix/QuoteMatrixModal.vue')
	),
	QuoteToTaskAssignees: defineAsyncComponent(
		() =>
			import('./components/QuoteToTaskAssignees/QuoteToTaskAssignees.vue')
	),
};
